import dynamic from 'next/dynamic';

import { Hero } from './components/Hero/Hero';
import { WhySellAtCatawiki } from './features/WhySellAtCatawiki/WhySellAtCatawiki';
import { SecureSales } from './components/SecureSales/SecureSales';
import { Experts } from './features/Experts/Experts';
import { FAQ } from './features/FAQ/FAQ';
import { HowSellingWithUsWorks } from './components/HowSellingWithUsWorks/HowSellingWithUsWorks';

const RecentlySold = dynamic(
  () =>
    import('./features/RecentlySold/RecentlySold').then(
      (module) => module.RecentlySold
    ),
  {
    ssr: false,
  }
);

type SellerRegisterProps = {
  isUserLoggedIn: boolean;
  APP_IMGPROXY_HOST: string;
};

export const SellerRegister = ({
  isUserLoggedIn,
  APP_IMGPROXY_HOST,
}: SellerRegisterProps) => (
  <main>
    <div className="u-wrapper">
      <Hero isLoggedIn={isUserLoggedIn} />

      <WhySellAtCatawiki />

      <RecentlySold
        isLoggedIn={isUserLoggedIn}
        APP_IMGPROXY_HOST={APP_IMGPROXY_HOST}
      />

      <SecureSales />

      <Experts />
    </div>
    {/* 
      How selling with us works has a full width container with different background color, 
      so it's kept out of u-wrapper here
    */}
    <HowSellingWithUsWorks isLoggedIn={isUserLoggedIn} />
    <div className="u-wrapper">
      <FAQ />
    </div>
  </main>
);
